$(document).ready(() => {
    let videos = $('.zone-merch-wrapper .zdm-video');

    videos.each((index, item) => {
        let wrapper = $(item);
        let parent = wrapper.parent().parent().parent();
        let iframe = wrapper.find('iframe');

        if (parent.length > 0) {
            let parentHeight = parent.height();
            let parentWidth = parent.width();

            // En desktop, la hauteur d�pend du voisin pour MEA2 ou TGTOP, en mobile il passe en full largeur donc pas de voisin, alors on lui fixe une hauteur prenant en compte le ratio de la vid�o originale
            parentHeight == 0 && window.innerWidth < 641 ? parentHeight = parentWidth * (9 / 16) : ''

            if (iframe.length > 0) {
                wrapper.height(parentHeight);
                wrapper.width(parentWidth);
                iframe.attr({
                    'height': parentHeight,
                    'width': parentWidth
                })
            }
        }
    })
})